import { render } from "./ResultSlide.vue?vue&type=template&id=e2d7720a&scoped=true"
import script from "./ResultSlide.vue?vue&type=script&lang=js"
export * from "./ResultSlide.vue?vue&type=script&lang=js"

import "./ResultSlide.vue?vue&type=style&index=0&id=e2d7720a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2d7720a"]])

export default __exports__